import script from "./DashboardKpi.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardKpi.vue?vue&type=script&setup=true&lang=js"

import "./DashboardKpi.vue?vue&type=style&index=0&id=34407810&lang=css"

const __exports__ = script;

export default __exports__